import { render, staticRenderFns } from "./printTag2.vue?vue&type=template&id=571b2f28&scoped=true&"
import script from "./printTag2.vue?vue&type=script&lang=js&"
export * from "./printTag2.vue?vue&type=script&lang=js&"
import style0 from "./printTag2.vue?vue&type=style&index=0&id=571b2f28&prod&lang=less&"
import style1 from "./printTag2.vue?vue&type=style&index=1&id=571b2f28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b2f28",
  null
  
)

export default component.exports